import React, { useRef } from "react";
import { AddMap, AddGeoJSON, FitBoundsPolygon} from "../hooks/mapFunctions.js";

const DEFAULT_COLORS = ["#f76e24", "#ff9e59", "#ffb380", "#ffd1a3", "#ffe6cc"];

export default function MapDistrict({ tableData}) {
  const mapContainer = useRef(null);
  const mapRef = AddMap(mapContainer);
  const geoData = AddGeoJSON(mapRef, "/geojson/districts.geojson", tableData, DEFAULT_COLORS);
  FitBoundsPolygon(mapRef, geoData);

  return (
    <div
      ref={mapContainer}
      style={{ width: "100%", height: "200px", borderRadius: "12px", overflow: "hidden" }}
    />
  );
}
